import axios from "axios";
import {
  getToken as _getTokenFromRefresh,
  handleAuthError,
  resetAuthRetryCount,
  createAuthRetryState,
} from "./_tokenRefresh";

export let baseUrl = "https://api.skedsocial.com";

// for when you're testing the API locally
let useLocal = false;

// SKED_API_ENV overrides NODE_ENV for API URL selection
const apiEnv = process.env.SKED_API_ENV || process.env.NODE_ENV;

if (apiEnv === "staging" || apiEnv === "dev") {
  if (useLocal) {
    baseUrl = "http://localhost:5001";
  } else {
    baseUrl = "https://api-staging.skedsocial.com";
  }
}

const defaultOptions = {
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
};

/** option to force getting token from server, there is a problem when
 * skedApiToken did not clean up after logout (or token expired), and pusher used the old token
 */
export function getToken(forceRequest) {
  return _getTokenFromRefresh(forceRequest);
}

export const skedApi = axios.create(defaultOptions);

skedApi.interceptors.request.use(async (config) => {
  const token = await getToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, null);

const skedApiRetryState = createAuthRetryState();

skedApi.interceptors.response.use(
  (response) => {
    resetAuthRetryCount(skedApiRetryState);
    return response;
  },
  async (error) => {
    console.group("Error in skedApi");
    console.error(error);
    console.dir(error);
    console.groupEnd();

    if (error?.response?.status === 401) {
      return handleAuthError(skedApi, error, "skedApi", skedApiRetryState);
    } else {
      throw error;
    }
  }
);
